import {
  isSelfHandledAuthEntryPath,
  UrlParamKey,
} from '~/client/src/shared/constants/commonRoutes'
import { EffectMap } from '~/client/src/shared/stores/EventStore/BaseEvents.store'
import * as e from '~/client/src/shared/stores/EventStore/eventConstants'
import InitialState from '~/client/src/shared/stores/InitialState'

export default function handleLoginAuthEntry(
  state: InitialState,
  urlParams: URLSearchParams,
): void | EffectMap {
  const passwordResetCode = urlParams.get(UrlParamKey.PasswordResetCode)
  if (passwordResetCode) {
    return {
      dispatch: [e.VERIFY_PASSWORD_RESET_CODE, passwordResetCode],
    }
  }

  // Self-handled auth entry (see isSelfHandledAuthEntryPath): the callback view
  // exchanges the code then continues with INIT_AUTH_USER; the admin-consent
  // view just renders the consent result.
  if (isSelfHandledAuthEntryPath(state.initPathname)) {
    state.onAuthStateChangedCallback()
    return {
      dispatch: [e.INIT_COMPLETE],
    }
  }
}
